import isEmpty from 'lodash/isEmpty'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import EmailForm from 'base/components/forms/email_form'
import { getErrorsForUserAccountData } from 'base/validators'
import { get } from 'base/lib/network'
import apiUrl from 'base/api_url'
import { saveVisitor } from 'base/actions/asynchronous'
import { connect } from 'react-redux'
import Hub from 'base/hub'
import Event from 'base/event'

class EmailCheckForm extends Component {
  static propTypes = {
    onEmailChecked: PropTypes.func,
    hideLoader: PropTypes.bool,
    siteLocation: PropTypes.string,
  }

  static defaultProps = {
    hideLoader: false,
  }

  state = {
    isNewUser: false,
    isLoading: false,
    serverErrorMessage: '',
    errorsForCheckEmail: {},
  }

  handleServerError = ({ responseJSON }) => {
    if (responseJSON && responseJSON.message) {
      this.setState({ errorsForCheckEmail: { email: responseJSON.message } })
    } else {
      this.setState({
        errorsForCheckEmail: { email: 'An unknown error occurred' },
      })
    }
  }

  handleCheckEmail = async email => {
    Hub.pub(Event.Login.EMAIL_ENTERED, {
      site_location: this.props.siteLocation,
    })

    const errors = getErrorsForUserAccountData({ email: email })

    if (!isEmpty(errors)) {
      this.setState({ errorsForCheckEmail: errors })
      return
    }

    this.setState({ errorsForCheckEmail: {}, isLoading: true, email })

    this.props
      .checkEmailAvailability({ email, site_location: this.props.siteLocation })
      .then(({ is_available }) => {
        this.props.saveVisitor({ email })
        this.setState({
          isNewUser: is_available,
          serverErrorMessage: null,
        })

        if (this.props.onEmailChecked) {
          this.props.onEmailChecked({ isNewUser: is_available, email: email })
        }
      })
      .fail(this.handleServerError)
      .always(() => this.setState({ isLoading: false }))
  }

  render() {
    return (
      <EmailForm
        errors={this.state.errorsForCheckEmail}
        isLoading={this.state.isLoading}
        hideLoader={this.props.hideLoader}
        onSubmit={this.handleCheckEmail}
        isFooter
      />
    )
  }
}

function mapStateToProps(state) {
  return { visitor: state.session.visitor }
}

function mapDispatchToProps(dispatch) {
  return {
    saveVisitor: newAttributes => dispatch(saveVisitor(newAttributes)),
    checkEmailAvailability: authData => get(apiUrl('users/availability'), authData),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailCheckForm)
